import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { categories } from "@/mocks/works";

export default function CategoryGrid() {
  return (
    <section className="px-4 md:px-8 py-14 md:py-20 bg-background-100 border-y border-background-200">
      <SectionHeading
        eyebrow="Categories"
        title="按方向翻作品"
        desc="六个投稿方向的分类入口，点进去就能按主题连续阅读同一类别的参赛作品。"
        linkTo="/works"
        linkLabel="全部作品集"
      />

      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {categories.map((cat) => (
          <Link
            key={cat.id}
            to={`/works?category=${cat.id}`}
            className="group flex items-start gap-4 p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
          >
            <span className="w-12 h-12 shrink-0 flex items-center justify-center rounded-md bg-primary-100 text-primary-600 text-2xl group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
              <i className={cat.icon} />
            </span>
            <span className="min-w-0 flex-1">
              <span className="flex items-center justify-between gap-2">
                <span className="font-heading text-base font-bold text-foreground-950">{cat.name}</span>
                <span className="w-4 h-4 flex items-center justify-center text-foreground-400 group-hover:text-primary-600 transition-colors">
                  <i className="ri-arrow-right-up-line" />
                </span>
              </span>
              <span className="mt-1.5 block text-sm text-foreground-600 leading-relaxed">{cat.desc}</span>
              <span className="mt-3 inline-flex items-center gap-1 text-xs text-secondary-900 bg-secondary-100 px-2.5 py-1 rounded-full">
                收录 {cat.count.toLocaleString("zh-CN")} 篇
              </span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}